import {instance} from "../rest_service";
import {getToken} from "../local_service";


export const createProfile = async (payload: any) => {
  return await instance.post("v1/user/create-profile", payload, {})
}

export const createPassword = async (payload: any) => {
  return await instance.post("/v1/user/save-password", payload, {})
}


export const updateEmail = async (payload:any) =>{
  return await instance.post("/v1/user/update-email", payload, {})
}

export const getUserInfo = async (token:string) => {
  const AUTH_TOKEN = getToken();

  if(!token || !AUTH_TOKEN){
    return {data: {}};
  }

  return await instance.get("/v1/user/user-info", {
    headers:{
      "Authorization": `Bearer ${token ?? AUTH_TOKEN}`
    }
  })
}

export const updateUserInfo = async (info:any) => {
  return await instance.put("/v1/user/update-info", info);
}

export const completeDriverSetUp = (data:any)=> instance.post("/v1/user/driver/create-profile", data)

export const updateDriverInfo = (driverId:number, data:any) =>
  instance.patch("/v1/user/driver/update-profile/"+driverId, data)

export const setDefaultSocialLogin = (data:any) => {
  return instance.post("/v1/user/set-social-login", data)
}

export const getUserNotifications = () => instance.get("/v1/app/get-notification")

export const clearUserNotification = (notificationId: string) => instance.delete(`/v1/app/notification/${notificationId}`);

export const clearAllNotifications = () => instance.get("/v1/app/notifications/clear")

export const inviteSubAccount = (data:any) => instance.post("/v1/user/add-user", data, {})

export const updateSubAccount = (data:any) => instance.patch("/v1/user/sub-account", data, {});

export const contractorAddNewAccount = (data:any) => instance.post("/v1/user/add-contractor", data, {})

export const saveDeviceNotificationToken = (data:any) => instance.post("/v1/user/notification/update-token", data, {})

export const getUserInviteDetails = (code?:string) => instance.get(`/v1/app/invite/${code}/details`);

export const getPlatformInviteDetails = (token : string) => instance.get(`/v1/user/invite/${token}/details`)

export const getUserNotificationTokens = () => {
  return instance.get("/v1/user/notification/tokens");
}